var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-card-block card sm-radius"},[_c('custom-file')],1)}
var staticRenderFns = []

export { render, staticRenderFns }